import React, {Component} from 'react';
import {connect} from 'react-redux';
import {loginUser} from '../../redux/actions';
import {companyDetails} from '../../helpers';
import { MailBox, Seo, ContentAdSlot } from '../shared';
import { Link } from 'react-router-dom';
import { SUPPORT_FALLBACK_FAQS } from '../../data/supportFallbackFaqs';
import {Tab, Accordion, Icon, Search} from 'semantic-ui-react';
import axios from 'axios';
import {passCsrfToken, toTableData} from '../../helpers';
import swal from 'sweetalert';
import {getFaqs} from '../../api/supportApi';
import {sendEmail} from '../../api/userApi';
import _ from 'lodash';

class CustomerSupport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			faqs: [],
			activeIndex: 0,
			selectedCategory: null,
			isLoading: false,
			results: [],
			value: '',
			searchedFaq: null
		};
	}

	componentDidMount() {
		passCsrfToken(document, axios);
		this.fetchFaqs();
	}

		fetchFaqs(params) {
			getFaqs(params)
				.then((response) => {
					const data = response.data;
					const list = Array.isArray(data) ? data : (data && data.faqs) || [];
					this.setState({ faqs: list });
				})
				.catch((error) => {
					console.log(' Faq fetch error', error);
					this.setState({ faqs: [] });
				});
		}

	emailUser(variables) {
		sendEmail(variables)
			.then((response) => {
				// console.log(response);
				swal({
					title: 'Email Sent!',
					text: response.data.message,
					icon: 'success',
					button: 'Continue!'
				});
			})
			.catch((error) => {
				console.log('support email error', error);
			});
	}

	handleClick = (e, titleProps) => {
		const {index} = titleProps;
		const {activeIndex} = this.state;
		const newIndex = activeIndex === index ? -1 : index;

		this.setState({activeIndex: newIndex});
	};

	handleResultSelect = (e, {result}) => this.setState({value: result.title, searchedFaq: result});

	handleSearchChange = (e, {value}) => {
		this.setState({isLoading: true, value});

		setTimeout(() => {
			if (this.state.value.length < 1)
				return this.setState({
					isLoading: false,
					results: [],
					value: '',
					searchedFaq: null
				});

			var results = _.filter(this.state.faqs || [], function(e) {
				return (e && (e.question || '')).toLowerCase().includes(value.toLowerCase());
			}).map((v) => ({
				title: v.question,
				description: v.answer
			}));
			this.setState({
				isLoading: false,
				results: results
			});
			// getFaqs(`q[question_cont]=${value}`).then((response) => {
			// 	var results = response.data.map((v) => ({
			// 		title: v.question,
			// 		description: v.answer
			// 	}));
			// 	this.setState({
			// 		isLoading: false,
			// 		results: results
			// 	});
			// });
		}, 0);
	};

	render() {
		const {faqs, activeIndex, selectedCategory} = this.state;
		const {isLoading, value, results, searchedFaq} = this.state;
		const {currentUser} = this.props;
		const userEmail = (currentUser && currentUser.email) || '';
		const hasCaptcha = !!(process.env.REACT_APP_CAPTCHA_KEY);
		const displayFaqs = (faqs && faqs.length > 0) ? faqs : SUPPORT_FALLBACK_FAQS;
		const phoneHref = `tel:${companyDetails.code}${companyDetails.contact}`;
		const phoneDisplay = `${companyDetails.code} ${companyDetails.contact}`;

		const panes = [
			{
				menuItem: 'Email Us',
				render: () => (
					<Tab.Pane attached={false}>
						<div className='row'>
							<div className='col-md-6 offset-md-3'>
								{hasCaptcha ? (
									<MailBox
										values={{
											description: '',
											subject: '',
											email: userEmail,
											captcha: ''
										}}
										sendEmail={(values) => this.emailUser(values)}
									/>
								) : (
									<div className='p-3 border rounded'>
										<p className='mb-2'>Email us and we&apos;ll get back to you.</p>
										<p className='mb-0'>
											<a href={`mailto:${companyDetails.email}`} className='btn btn-primary'>{companyDetails.email}</a>
										</p>
									</div>
								)}
							</div>
						</div>
					</Tab.Pane>
				)
			},
			{
				menuItem: 'Text',
				render: () => (
					<Tab.Pane attached={false}>
						<div className='text-center'>
							<div>{companyDetails.email}</div>
							<a href={`tel:${companyDetails.code}${companyDetails.contact}`} className='btn btn-secondary btn-large m-2'>
								{phoneDisplay}
							</a>
						</div>
					</Tab.Pane>
				)
			}
		];
		return (
			<div className=''>
				<Seo
					title="Customer Support"
					path="/support"
					description="Get help with bookings, payments, and trip planning for Visit All Nepal. Search our FAQs or contact our support team directly."
				/>
				<section className='bg-primary text-center'>
					<div className='container py-4'>
						<h1 className='text-white text-larger mb-2'>Customer support</h1>
						<p className='text-white mb-3 mx-auto' style={{ maxWidth: '42rem', opacity: 0.92 }}>
							Help with bookings, payments, and trip planning. Email{' '}
							<a href={`mailto:${companyDetails.email}`} className='text-white font-weight-bold'>
								{companyDetails.email}
							</a>
							{' '}or WhatsApp{' '}
							<a href={phoneHref} className='text-white font-weight-bold'>{phoneDisplay}</a>.
						</p>
						<Search
							fluid
							loading={isLoading}
							onResultSelect={this.handleResultSelect}
							onSearchChange={this.handleSearchChange}
							results={results || []}
							value={value}
							className='w-100 search-faq'
							placeholder='Search FAQs (e.g. booking, payment)'
						/>
					</div>
				</section>
				<div className='container py-4'>
					<ContentAdSlot layout="support" className="adsense-unit--in-content mb-4" />
					{searchedFaq !== null && (
						<div className='card'>
							<div className='card-body'>
								<h3>{searchedFaq.title}</h3>
								<p>{searchedFaq.description}</p>
							</div>
						</div>
					)}
					<div className='card mt-4'>
						<div className='card-body'>
							<div className='d-flex'>
								{/* <div
									className='widget p-2'
									onClick={() => {
										this.setState({
											selectedCategory: 'flight'
										});
										this.fetchFaqs(`q[category_eq]=flight`);
									}}
								>
									<div className='text-center cursor-pointer'>
										<i
											className={`${selectedCategory == 'flight'
												? 'active'
												: ''} fas fa-2x fa-plane departure mb-2`}
										/>
										<h3 className='count'>Flights</h3>
									</div>
								</div> */}
								<div
									className='widget p-2'
									onClick={() => {
										this.setState({
											selectedCategory: 'package'
										});
										this.fetchFaqs(`q[category_eq]=package`);
									}}
								>
									<div className='text-center cursor-pointer'>
										<i
											className={`${selectedCategory == 'package'
												? 'active'
												: ''} fas fa-2x fa-briefcase mb-2`}
										/>
										<h3 className='count'>Private Tours</h3>
									</div>
								</div>
								<div
									className='widget p-2'
									onClick={() => {
										this.setState({
											selectedCategory: 'rental'
										});
										this.fetchFaqs(`q[category_eq]=rental`);
									}}
								>
									<div className='text-center cursor-pointer'>
										<i
											className={`${selectedCategory == 'rental'
												? 'active'
												: ''} fas fa-2x fa-car mb-2`}
										/>
										<h3 className='count'>Rental</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='card mt-4'>
						<div className='card-body'>
							<h3 className='title'>Frequently asked questions</h3>
							{(faqs || []).length === 0 && (
								<p className='text-muted small mb-3'>
									Planning a trip? Also browse our{' '}
									<Link to="/journeys">guided journeys</Link>,{' '}
									<Link to="/guides">travel guides</Link>, and{' '}
									<Link to="/about">about page</Link>.
								</p>
							)}
							<Accordion styled fluid className='border-none'>
								{displayFaqs.map((faq, index) => {
									return (
										<React.Fragment>
											<Accordion.Title
												active={activeIndex === index}
												index={index}
												onClick={this.handleClick}
											>
												<Icon name='dropdown' />
												{faq.question}
											</Accordion.Title>
											<Accordion.Content active={activeIndex === index}>
												<p>{faq.answer}</p>
											</Accordion.Content>
										</React.Fragment>
									);
								})}
							</Accordion>
						</div>
					</div>
				</div>
				<section className='bg-white'>
					<div className='container'>
						<h3 className='title'>You can also</h3>
						<Tab menu={{secondary: true}} panes={panes} />
					</div>
				</section>
			</div>
		);
	}
}
const mapStateToProps = ({userStore}) => {
	return {
		currentUser: userStore.currentUser
	};
};

const mapDispatchToProps = {
	loginUser
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSupport);
